var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-application v-application--is-ltr vuetify-wrapper" },
    [
      _c(
        "section",
        { staticClass: "v-application align-center" },
        [
          _c("h3", { staticClass: "mb-5" }, [
            _vm._v(
              _vm._s(_vm.isRestricted ? "Steffi Anfragen" : "Steffi Kunden")
            ),
          ]),
          _vm._v(" "),
          _vm.isRestricted
            ? _c("steffi-offline-contract-dialog", {
                on: {
                  saved: function ($event) {
                    return _vm.fetchCustomers()
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("steffi-offline-trial-dialog", {
            on: {
              saved: function ($event) {
                return _vm.fetchCustomers()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "v-application v-application--is-ltr" },
        [
          _c(
            "v-card-text",
            [
              _vm.error
                ? _c(
                    "v-alert",
                    { attrs: { type: "error", dense: "", outlined: "" } },
                    [
                      _vm._v(
                        "\n                Steffi Kunden konnten nicht geladen werden.\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "v-application" },
                [
                  _vm.isRestricted
                    ? _c(
                        "v-col",
                        { staticClass: "pt-1", attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-chip-group",
                            {
                              attrs: {
                                mandatory: "",
                                dense: "",
                                color: "primary",
                                "data-test": "steffi-queue-filter",
                              },
                              model: {
                                value: _vm.filters.queue,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "queue", $$v)
                                },
                                expression: "filters.queue",
                              },
                            },
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    value: "open",
                                    "data-test": "steffi-queue-open",
                                  },
                                },
                                [_vm._v("Offen")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    value: "all",
                                    "data-test": "steffi-queue-all",
                                  },
                                },
                                [_vm._v("Alle")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: "Suche nach Apotheke, ID, Telefon",
                          "data-test": "steffi-customer-search",
                          clearable: "",
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.filters.search,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "search", $$v)
                          },
                          expression: "filters.search",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "3",
                        "data-test": "steffi-status-filter",
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.localStatusOptions,
                          label: "FPP Status",
                          clearable: "",
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.filters.local_status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "local_status", $$v)
                          },
                          expression: "filters.local_status",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.famulorStatusOptions,
                          label: "Technischer Status",
                          clearable: "",
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.filters.famulor_status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "famulor_status", $$v)
                          },
                          expression: "filters.famulor_status",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.planOptions,
                          label: "Paket",
                          clearable: "",
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.filters.plan_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "plan_code", $$v)
                          },
                          expression: "filters.plan_code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", { staticClass: "mt-2" }),
          _vm._v(" "),
          _c("v-data-table", {
            staticClass: "v-application--is-ltr",
            attrs: {
              headers: _vm.headers,
              items: _vm.customers,
              options: _vm.tableOptions,
              "server-items-length": _vm.total,
              loading: _vm.isLoading,
              "mobile-breakpoint": "900",
              "loading-text": "Wird geladen...",
              "no-data-text": "Keine Steffi Kunden gefunden",
              "footer-props": {
                "items-per-page-options": [10, 25, 50, 100],
                "show-first-last-page": true,
                "show-current-page": true,
                "items-per-page-text": "Zeilen pro Seite",
              },
            },
            on: {
              "update:options": [
                function ($event) {
                  _vm.tableOptions = $event
                },
                _vm.onOptionsChange,
              ],
            },
            scopedSlots: _vm._u([
              {
                key: "item.pharmacy_customer_id",
                fn: function ({ item }) {
                  return [
                    item.pharmacy_customer_id
                      ? _c("span", { staticClass: "text-caption" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.pharmacy_customer_id) +
                              "\n                "
                          ),
                        ])
                      : _c("span", { staticClass: "text--secondary" }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
              {
                key: "item.pharmacy_name",
                fn: function ({ item }) {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "steffi-pharmacy-link",
                        attrs: {
                          href: _vm.pharmacyLink(item),
                          "data-test": "steffi-pharmacy-link",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.pharmacy_name) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "item.callable_phone",
                fn: function ({ item }) {
                  return [
                    _c("section", { staticClass: "numbers" }, [
                      item.famulor_phone_number
                        ? _c(
                            "div",
                            { staticClass: "v-application phone-container" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: `tel:${item.famulor_phone_number}`,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.famulor_phone_number) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "caption" }, [
                                _vm._v("(Steffi Nummer)"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.pharmacy_phone_number
                        ? _c(
                            "div",
                            { staticClass: "v-application phone-container" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: `tel:${item.pharmacy_phone_number}`,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.pharmacy_phone_number) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "caption" }, [
                                _vm._v("(Apothekenprofil)"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
              {
                key: "item.local_subscription_status",
                fn: function ({ item }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "v-application v-application--is-ltr" },
                      [
                        _c(
                          "v-chip",
                          {
                            staticClass: "lighten-4 font-weight-medium",
                            attrs: {
                              small: "",
                              color: _vm.localStatusColor(
                                item.local_subscription_status
                              ),
                              "text-color": `${_vm.localStatusColor(
                                item.local_subscription_status
                              )} darken-2`,
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.localStatusLabel(
                                    item.local_subscription_status
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.trial_status",
                fn: function ({ item }) {
                  return [
                    item.trial_status
                      ? _c(
                          "div",
                          {
                            staticClass: "py-2",
                            attrs: {
                              "data-test": "steffi-overview-trial-status",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "font-weight-medium mb-1" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      item.trial_expired
                                        ? "Testphase automatisch beendet"
                                        : _vm.trialStatusLabel(
                                            item.trial_status
                                          )
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            item.trial_started_at
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "text-no-wrap",
                                    attrs: {
                                      "data-test": "steffi-trial-start",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text--secondary" },
                                      [_vm._v("Start:")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatTrialDate(
                                            item.trial_started_at
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.trial_ends_at
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "text-no-wrap",
                                    attrs: { "data-test": "steffi-trial-end" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text--secondary" },
                                      [_vm._v("Ende:")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatTrialDate(
                                            item.trial_ends_at
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.trial_started_at || item.trial_ends_at
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "text-caption text--secondary",
                                  },
                                  [_vm._v("Berliner Zeit")]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _c("span", { staticClass: "text--secondary" }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
              {
                key: "item.famulor_operational_status",
                fn: function ({ item }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "v-application v-application--is-ltr" },
                      [
                        _c(
                          "v-chip",
                          {
                            staticClass: "lighten-4 font-weight-medium",
                            attrs: {
                              small: "",
                              color: _vm.famulorStatusColor(
                                item.famulor_operational_status
                              ),
                              "text-color": `${_vm.famulorStatusColor(
                                item.famulor_operational_status
                              )} darken-2`,
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.famulorStatusLabel(
                                    item.famulor_operational_status
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.plan_code",
                fn: function ({ item }) {
                  return [
                    _c("div", { staticClass: "bold" }, [
                      _vm._v(
                        _vm._s(item.plan_name || _vm.planLabel(item.plan_code))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "item.technical_test_finished",
                fn: function ({ item }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "v-application" },
                      [
                        _c("v-checkbox", {
                          staticClass: "mt-0 pt-0",
                          attrs: {
                            "input-value": item.technical_test_finished,
                            loading: _vm.technicalTestSavingIds.includes(
                              item.pharmacy_id
                            ),
                            disabled:
                              !item.can_update_technical_test ||
                              _vm.technicalTestSavingIds.includes(
                                item.pharmacy_id
                              ),
                            "hide-details": "",
                            "data-test": `${item.pharmacy_id}-steffi-technical-test-finished-item`,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setTechnicalTestFinished(item, $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "item.start_date",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formatDateOnly(item.start_date) || "-") +
                        "\n            "
                    ),
                  ]
                },
              },
              {
                key: "item.requested_at",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formatDateOnly(item.requested_at) || "-") +
                        "\n            "
                    ),
                  ]
                },
              },
              {
                key: "item.next_billing_date",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.formatDateOnly(item.next_billing_date) || "-"
                        ) +
                        "\n            "
                    ),
                  ]
                },
              },
              {
                key: "item.open_invoice_count",
                fn: function ({ item }) {
                  return [
                    _c("section", { staticClass: "counts" }, [
                      _c("div", [
                        _c("strong", [
                          _vm._v(_vm._s(item.invoice_summary.open_count)),
                        ]),
                        _vm._v(" offen\n                    "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text--secondary text-caption" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.invoice_summary.paid_count) +
                              " bezahlt\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text--secondary text-caption" },
                        [
                          _vm._v(
                            _vm._s(item.invoice_summary.created_count) +
                              " vorbereitet"
                          ),
                        ]
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "item.usage_total_minutes",
                fn: function ({ item }) {
                  return [
                    _c(
                      "section",
                      {
                        attrs: {
                          "data-test": "steffi-usage",
                          "data-pharmacy-id": item.pharmacy_id,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            attrs: {
                              "data-test": "steffi-usage-sync",
                              "data-state": item.usage_sync.state,
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.usageSyncLabel(item.usage_sync.state)
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        !item.usage_sync.last_success_at &&
                        !["never_synced", "not_applicable"].includes(
                          item.usage_sync.state
                        )
                          ? _c("div", { staticClass: "text-caption" }, [
                              _vm._v(
                                "\n                        Nutzungsdaten noch nicht synchronisiert\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.usage_sync.last_success_at
                          ? _c("div", { staticClass: "text-caption" }, [
                              _vm._v(
                                "\n                        Letzte erfolgreiche Synchronisierung: " +
                                  _vm._s(
                                    _vm.formatTrialDate(
                                      item.usage_sync.last_success_at
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.usage_sync.last_success_at ||
                        item.usage_summary.total_call_count
                          ? _c(
                              "div",
                              { attrs: { "data-test": "steffi-usage-counts" } },
                              [
                                item.usage_sync.state !== "fresh"
                                  ? _c("div", { staticClass: "text-caption" }, [
                                      _vm._v(
                                        "Bekannte Nutzung (unvollständig)"
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      item.usage_summary.total_call_count
                                    ) + " Calls"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text--secondary text-caption",
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          item.usage_summary
                                            .total_billable_minutes
                                        ) +
                                        " Min.\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "item.links",
                fn: function ({ item }) {
                  return [
                    _c(
                      "section",
                      { staticClass: "urls" },
                      [
                        _vm._l(item.invoices, function (invoice) {
                          return _c(
                            "v-tooltip",
                            {
                              key: invoice.invoice_id,
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "a",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "ml-1",
                                                attrs: {
                                                  href: `${_vm.apobilanzOriginUrl}/product-invoices/${invoice.id}`,
                                                  target: "_blank",
                                                  rel: "noopener",
                                                  title:
                                                    "Rechnungen in Apobilanz",
                                                },
                                              },
                                              "a",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-file-link-outline")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(invoice.ref) +
                                    "\n                        "
                                ),
                              ]),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        item.legal_acceptance &&
                        item.legal_acceptance.contract_url
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: item.legal_acceptance.contract_url,
                                    target: "_blank",
                                    rel: "noopener",
                                  },
                                },
                                [_vm._v("Vertragsset öffnen")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.legal_acceptance && item.legal_acceptance.agb_url
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: item.legal_acceptance.agb_url,
                                    target: "_blank",
                                    rel: "noopener",
                                  },
                                },
                                [_vm._v("Nutzungsbedingungen öffnen")]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }